import { render, staticRenderFns } from "./Electronic.vue?vue&type=template&id=214e225a&scoped=true&"
import script from "./Electronic.vue?vue&type=script&lang=js&"
export * from "./Electronic.vue?vue&type=script&lang=js&"
import style0 from "./Electronic.vue?vue&type=style&index=0&id=214e225a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e225a",
  null
  
)

export default component.exports